import { BindAll } from 'lodash-decorators'
import type { CityTypeInfo } from '@xt/client/entities/kindred-spirit/kindred-spirit'
import { $service } from '@xt/client/experimental/request/service'
import { EnumApiTonghao } from '@xt/client/api/kindred-spirit'
import { action, observable, computed } from 'mobx'

export enum EnumCityStatus {
  /** 未创建 */
  NotInited = 0,
  /** 助力中 */
  Assistance = 1,
  /** 招募中 */
  Recruitment = 2
}

@BindAll()
export class Cities {
  constructor() {}

  @observable cities: Array<CityTypeInfo> = [
    {
      id: 1,
      name: '宁波分桐',
      cover: 'https://picsum.photos/id/102/300/180',
      count: 2460,
      description: '宁波本地同城交流社群，线下定期组织活动',
      memberIds: [5, 17, 44, 92],
      status: 1
    },
    {
      id: 0,
      name: '杭州分桐',
      cover: 'https://picsum.photos/id/237/300/180',
      count: 0,
      description: 'adsdqdw1',
      memberIds: [12, 36, 89],
      status: 1
    },
    {
      id: 2,
      name: '温州分桐',
      cover: '',
      count: 0,
      description: '创业同行交流，资源互换对接平台',
      memberIds: [],
      status: 2
    },
    {
      id: 3,
      name: '嘉兴分桐',
      cover: 'https://picsum.photos/id/145/300/180',
      count: 0,
      description:
        '休闲生活圈子，探店出游日常分享，休闲生活圈子，探店出游日常分享，休闲生活圈子，探店出游日常分享，休闲生活圈子，探店出游日常分享',
      memberIds: [22, 67, 101, 156],
      status: 0
    },
    {
      id: 4,
      name: '绍兴分桐',
      cover: '',
      count: 648,
      description: '古风文化爱好者聚集地，研学结伴出行',
      memberIds: [31, 78],
      status: 0
    },
    {
      id: 5,
      name: '金华分桐',
      cover: 'https://picsum.photos/id/169/300/180',
      count: 1890,
      description: '电商商家交流社群，供应链信息共享',
      memberIds: [9, 47, 123],
      status: 2
    },
    {
      id: 6,
      name: '台州分桐',
      cover: 'https://picsum.photos/id/201/300/180',
      count: 2710,
      description: '户外运动社群，爬山、露营、徒步组队',
      memberIds: [14, 55, 88, 132, 177],
      status: 2
    },
    {
      id: 7,
      name: '丽水分桐',
      cover: '',
      count: 526,
      description: '乡村文旅爱好者，小众景点打卡分享',
      memberIds: [],
      status: 0
    }
  ]

  @computed
  get firstCity() {
    return this.cities[0]
  }

  @computed
  get recommendCities() {
    return this.cities.slice(1, 8).map(i => {
      let subTitle: string = ''

      if (i.count) {
        subTitle = `${i.count}位桐学加入`
      } else {
        subTitle = i.status === EnumCityStatus.Assistance ? '即将开放' : '准备中...'
      }

      return {
        ...i,
        subTitle
      }
    })
  }

  /** 分桐模块
   * 1.根据定位获取对应城市的分桐信息 */

  // 获取定位推荐城市
  public async getLocateCities(locate?): Promise<Array<CityTypeInfo> | void> {
    if (!locate) return

    const [, data] = await $service<Array<CityTypeInfo>>({
      url: EnumApiTonghao.RecommendCitys,
      data: {
        locate
      }
    })

    if (Array.isArray(data) && data.length > 0) {
      return data
    }

    return []
  }

  // 获取推荐分桐
  public async getRecommendCities(): Promise<Array<CityTypeInfo>> {
    const [, data] = await $service<Array<CityTypeInfo>>({
      url: EnumApiTonghao.RecommendCitys,
      data: {}
    })

    if (Array.isArray(data) && data.length > 0) {
      return data
    }

    return []
  }

  // 桐学会城市列表页 - 获取已创建的城市列表
  public async getCreatedCityList() {}

  @action
  setCities(cities: Array<CityTypeInfo>) {
    this.cities = cities
  }
}
